import { AccountBoxMultipleIcon } from './AccountBoxMultipleIcon';

/**
 * author: Google
 * id D612088F-9D2A-424A-9403-046993A3EB14
 * name account-box-multiple
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-box-multiple.svg
 * tags
 * - Account / User 
 */
export const UserBoxMultipleIcon = AccountBoxMultipleIcon;
export default UserBoxMultipleIcon